import { LkFeaturesService } from './app/shared/utils/lkFeatureFlags';

const lkFeaturesService = new LkFeaturesService();
lkFeaturesService.init();
